import { useEffect, useRef, useCallback } from 'react';
import { sendHeartbeat, abandonExam } from '../api/submissionService';

const HEARTBEAT_INTERVAL = 5000;
const ABANDON_TIMEOUT = 3000;

const useHeartbeat = (examId, studentName, isActive, getState) => {
  const intervalRef = useRef(null);
  const getStateRef = useRef(getState);
  getStateRef.current = getState;

  const doHeartbeat = useCallback(async () => {
    if (!examId || !studentName || !isActive) return;
    const state = getStateRef.current();
    await sendHeartbeat({
      examId,
      studentName,
      faceDetected: state.faceDetected,
      answers: state.answers,
      violations: state.violations
    });
  }, [examId, studentName, isActive]);

  useEffect(() => {
    if (!isActive) return;

    doHeartbeat();
    intervalRef.current = setInterval(doHeartbeat, HEARTBEAT_INTERVAL);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, [isActive, doHeartbeat]);

  useEffect(() => {
    if (!isActive) return;

    const handleBeforeUnload = (e) => {
      const state = getStateRef.current();
      abandonExam({
        examId,
        studentName,
        answers: state.answers,
        violations: state.violations
      });
      e.preventDefault();
      e.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isActive, examId, studentName]);

  const abandon = useCallback(async () => {
    const state = getStateRef.current();
    await abandonExam({
      examId,
      studentName,
      answers: state.answers,
      violations: state.violations
    });
  }, [examId, studentName]);

  return { abandon, forceHeartbeat: doHeartbeat };
};

export default useHeartbeat;
export { HEARTBEAT_INTERVAL, ABANDON_TIMEOUT };
